import request from "@/utils/request";

// ============================================================
// AI 智能助手接口封装
// 后端：hbyg/src/main/java/com/hbyg/controller/AiChatController.java
// 设计：docs/AI助手-功能设计方案.md / docs/AI助手-原型.html
// 说明：对话 SSE 流在组件内用 fetch 处理（axios 不支持流式解析），
//       此处只封装 4 个会话管理 REST 端点。
// ============================================================

// 我的会话列表（分页）
export const aiSessions = (pageNo = 1, pageSize = 20) => {
  return request({ url: "/ai/sessions", method: "get", params: { pageNo, pageSize } });
};

// 某个会话的消息明细（还原历史界面）
export const aiMessages = (sessionId) => {
  return request({ url: `/ai/session/${sessionId}/messages`, method: "get" });
};

// 删除某个会话（含模型记忆 state 文件）
export const aiDeleteSession = (sessionId) => {
  return request({ url: `/ai/session/${sessionId}`, method: "delete" });
};

// 清空我的全部会话
export const aiClearSessions = () => {
  return request({ url: "/ai/session/clear", method: "post" });
};
